﻿import {
  deletePergunta,
  getAllPerguntaComResposta,
  getPerguntaComRespostaByPerguntaId,
  Pergunta,
  updatDescricaoPerguntaTipoPergunta,
  UpdatePergunta,
} from '@app/api/minuta/Pergunta';
import { getAllRespostaByPerguntaIdOptions, Resposta } from '@app/api/minuta/Resposta';
import { getAllTipoPerguntasOptions } from '@app/api/minuta/tipoPergunta';
import { EGuidPerguntaFixa } from '@app/enums/EGuidPerguntaFixa';
import { newGuid } from '@app/helpers/geradorGuid';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { TabelaPerguntas } from '@app/views';
import {
  Button,
  CompositeView,
  FormatText,
  FormInput,
  FormSelect,
  FormSubmitButton,
  FormTextArea,
  GridView,
  MasterDetailForm,
  OptionProps,
  SimpleView,
  usePromise,
  useRouter,
  Widget,
  notification,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import ModalCreateResposta from './ModalCreateResposta';
import TabelaResposta from './TabelaResposta';

const { Panel } = Collapse;

const Perguntas = () => {
  const [tipoPerguntaOptions] = usePromise(getAllTipoPerguntasOptions, [], [] as OptionProps[]);
  const [tipoMinutaOptions] = usePromise(getAllRespostaByPerguntaIdOptions(EGuidPerguntaFixa.QualTipoMinuta), [], [] as OptionProps[]);
  const [pergunta, setPergunta] = useState<Pergunta>({} as Pergunta);
  const [perguntaResult, setPerguntaResult] = useState<Pergunta[]>([]);
  const [initialValue, setInitialValue] = useState<Pergunta>();
  const { history } = useRouter();
  const [flag, setFlag] = useState(false);
  const [atualizarResultTabelaPerguntaOrdenacao, setAtualizarResultTabelaPerguntaOrdenacao] = useState(false);

  useEffect(() => {
    getAllPergunta();
  }, []);

  useEffect(() => {
    getAllPergunta();
  }, [history.location.pathname]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    let id = params.get('id');
    if (pergunta.id && !id) id = pergunta.id;
    if (id && flag === false) {
      getPerguntaSelected(id);
    } else {
      limparFormulario();
    }
  }, [window.location, perguntaResult]);

  const getPerguntaSelected = (idItem: string) => {
    getAllPerguntaComResposta().then(data => {
      if (data) {
        const result = data.find(obj => {
          return obj.id === idItem;
        });

        if (result) {
          const perguntaResult = result;

          const obj = {
            pergunta: perguntaResult.pergunta,
            tipoPerguntaId: perguntaResult.tipoPerguntaId,
            id: perguntaResult.id,
            respostas: perguntaResult.respostas,
            necessitaConfirmacaoDemandante: perguntaResult.necessitaConfirmacaoDemandante,
            necessitaObservacaoDemandante: perguntaResult.necessitaObservacaoDemandante,
            tituloPerguntaQuestionario: perguntaResult.tituloPerguntaQuestionario,
            tiposMinutaConfirmacaoDemandante: perguntaResult.tiposMinutaConfirmacaoDemandante,
            fixa: perguntaResult.fixa,
          } as Pergunta;

          setFlag(true);
          setInitialValue(obj);
          setPergunta(obj);
        }
      }
    });
  };

  const getPerguntaComResposta = (perguntaId: string) => {
    getPerguntaComRespostaByPerguntaId(perguntaId).then(data => {
      if (data) setPergunta(data);
    });
  };

  const atualizarListaPergunta = () => {
    setFlag(false);
    getAllPergunta();
  };

  const onUpdateModalCreateResposta = (values: any) => {
    const respostPut = values as Resposta;

    if (respostPut.descricao.replace(/\s/g, '').length != 0) {
      let respostaArray = [] as Resposta[];
      if (isObjNotEmpty(pergunta) && isObjNotEmpty(pergunta.respostas) && pergunta.respostas.length > 0) {
        respostaArray = pergunta.respostas;
        respostaArray.push(respostPut);
      } else {
        respostaArray.push(respostPut);
      }
      const novaPergunta = { ...pergunta, respostas: respostaArray };
      UpdatePergunta(novaPergunta).then(data => {
        if (data) {
          if (data != true) {
            const obj = {
              pergunta: data.pergunta,
              tipoPerguntaId: data.tipoPerguntaId,
              id: data.id,
              respostas: data.respostas,
              necessitaConfirmacaoDemandante: data.necessitaConfirmacaoDemandante,
              necessitaObservacaoDemandante: data.necessitaObservacaoDemandante,
              tituloPerguntaQuestionario: data.tituloPerguntaQuestionario,
              tiposMinutaConfirmacaoDemandante: data.tiposMinutaConfirmacaoDemandante,
            } as Pergunta;

            setPergunta(obj);
          } else {
            if (novaPergunta && novaPergunta.id) {
              getPerguntaComResposta(novaPergunta.id);
            } else {
            }
          }
        }
        atualizarListaPergunta();
        setAtualizarResultTabelaPerguntaOrdenacao(!atualizarResultTabelaPerguntaOrdenacao);
      });
    } else {
      notification.error('Reposta em branco.');
    }
  };

  const onSubmitSearchForm = (values: any) => {
    if (values.termo == '') {
      getAllPergunta();
    } else {
      getAllPerguntaComResposta().then(data => {
        if (data) {
          const filteredPerguntaResult = data.filter(per =>
            per.pergunta.toUpperCase().includes(values.termo.toUpperCase()),
          );
          setPerguntaResult(filteredPerguntaResult);
        }
      });
    }
  };

  const setValueTipoPergunta = (tipoPergunta: string) => {
    setPergunta({ ...pergunta, tipoPerguntaId: tipoPergunta } as Pergunta);
  };

  const setValuePerguntaDescricao = (descricao: string) => {
    setPergunta({ ...pergunta, pergunta: descricao } as Pergunta);
  };

  const getAllPergunta = () => {
    getAllPerguntaComResposta().then(data => {
      if (data) {
        setPerguntaResult(data);
      }
    });
  };

  const limparFormulario = () => {
    setPergunta({} as Pergunta);
    setInitialValue({
      ...initialValue,
      pergunta: '',
      descricao: '',
      idFace: newGuid(),
      tipoPerguntaId: '',
      id: '',
      respostas: [],
      necessitaConfirmacaoDemandante: '',
      necessitaObservacaoDemandante: '',
      tituloPerguntaQuestionario: '',
      tiposMinutaConfirmacaoDemandante: [],
    } as Pergunta);
  };

  const btns = () => {
    const buttons = [];
    buttons.push(<ModalCreateResposta onUpdate={onUpdateModalCreateResposta} />);

    if (pergunta.fixa !== true) {
      buttons.push(
        <Button
          type="danger"
          onClick={() => {
            isObjNotEmpty(pergunta)
              ? pergunta.id
                ? confirm('Esta ação também excluirá as respostas. Continuar?')
                  ? deletePergunta(pergunta.id).then(data => {
                    limparFormulario();
                    window.location.href = './perguntasCadastradas';
                  })
                  : ''
                : limparFormulario()
              : notification.error('Não há pergunta para ser excluída.');
          }}>
          Excluir Pergunta
        </Button>,
      );
    }

    buttons.push(
      <Button
        type="primary"
        style={{ marginLeft: '5px' }}
        onClick={() => {
          limparFormulario();
          history.push('./cadastroDePergunta');
          setFlag(true);
        }}
        icon="commons-news"
        size="small">
        NOVA PERGUNTA
      </Button>,
    );

    if (flag === true) {
      buttons.push(
        <FormSubmitButton noIcon type="success">
          <FormatText id="ui.commons.save" uppercase />
        </FormSubmitButton>,
      );
    }

    return buttons;
  };

  return (
    <SimpleView>
      <CompositeView>
        <GridView icon="ui-list" noform id="perguntasCadastradas" title="PERGUNTAS">
          <Collapse
            key="perguntasCadastradas"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'perguntasCadastradas'}>
            <Panel key="perguntasCadastradas" header="PESQUISAR">
              <MasterDetailForm initialValues={pergunta} onSubmit={onSubmitSearchForm}>
                <Widget
                  actions={[
                    true && (
                      <FormSubmitButton noIcon type="primary">
                        <FormatText id="ui.commons.search" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormInput label="Termo" name="termo" span={6} />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>

          <>
            {perguntaResult && perguntaResult.length > 0 ? (
              <>
                {perguntaResult.map(pergunta => {
                  return (
                    <Collapse key={`${pergunta.id}`} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                      <Panel key={`${pergunta.id}`} header={`${pergunta.ordenacao} - ${pergunta.pergunta}`}>
                        <Widget
                          actions={[
                            <>
                              {pergunta.fixa !== true ? (
                                <Button
                                  key="delete"
                                  type="danger"
                                  style={{ marginRight: '5px', marginLeft: '5px', marginBottom: '5px', float: 'right' }}
                                  onClick={() => {
                                    pergunta
                                      ? pergunta.id
                                        ? confirm('Esta ação também excluirá as respostas. Continuar?')
                                          ? (deletePergunta(pergunta.id).then(data => {
                                            getAllPergunta();
                                            setAtualizarResultTabelaPerguntaOrdenacao(
                                              !atualizarResultTabelaPerguntaOrdenacao,
                                            );
                                          }),
                                            limparFormulario())
                                          : ''
                                        : limparFormulario()
                                      : notification.error('Não há pergunta para ser excluída');
                                  }}>
                                  Excluir Pergunta
                                </Button>
                              ) : (
                                <></>
                              )}
                            </>,
                            <Button
                              key="edit"
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() => {
                                setFlag(false);
                                window.location.href = `./cadastroDePergunta?id=${pergunta.id}`;
                              }}>
                              Editar Pergunta
                            </Button>,
                          ]}>
                          <TabelaResposta perguntaResult={pergunta} atualizarListaPergunta={atualizarListaPergunta} />
                        </Widget>
                      </Panel>
                    </Collapse>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </>
        </GridView>

        <GridView icon="files-create_new" noform id="cadastroDePergunta" title="CADASTRO">
          <Collapse
            key="cadastroDePergunta"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'cadastroDePergunta'}>
            <Panel key="cadastroDePergunta" header="CADASTRO DE PERGUNTAS">
              <MasterDetailForm
                initialValues={initialValue}
                onSubmit={(values: Pergunta) => {
                  if (pergunta.pergunta.replace(/\s/g, '').length != 0)
                    updatDescricaoPerguntaTipoPergunta(pergunta).then(data => {
                      if (data && data.valid) {
                        window.location.href = './perguntasCadastradas';
                        limparFormulario();
                      }
                    });
                  else {
                    notification.error('Pergunta em branco');
                  }
                }}
                validationSchema={Yup.object().shape({
                  necessitaConfirmacaoDemandante: Yup.string().required('O campo deve ser informado'),
                  necessitaObservacaoDemandante: Yup.string().required('O campo deve ser informado'),
                  tituloPerguntaQuestionario: Yup.string().required('O campo deve ser informado'),
                })}>
                <Widget actions={btns()}>
                  <FormTextArea
                    label="Pergunta"
                    name="pergunta"
                    span={6}
                    maxLength={1000}
                    rows={6}
                    cols={60}
                    value={pergunta.pergunta}
                    onChange={(e: any) => {
                      setValuePerguntaDescricao(e.target.value);
                    }}
                    onBlur={e => {
                      setValuePerguntaDescricao(e.target.value);
                    }}
                  />

                  <FormSelect
                    label={'Tipo de Pergunta'}
                    name="tipoPerguntaId"
                    options={tipoPerguntaOptions}
                    required
                    span={2}
                    onChange={e => {
                      setValueTipoPergunta(e as string);
                    }}
                    id={'tipoPerguntaId'}
                  />

                  <FormSelect
                    label={'Necessita de Confirmação Demandante'}
                    name="necessitaConfirmacaoDemandante"
                    options={[
                      { text: 'Sim', value: 'True' },
                      { text: 'Não', value: 'False' },
                    ]}
                    required
                    span={2}
                    onChange={e => {
                      setPergunta({
                        ...pergunta,
                        ...{
                          necessitaConfirmacaoDemandante: e,
                          tiposMinutaConfirmacaoDemandante: tipoMinutaOptions.map(m => m.value),
                        },
                      } as Pergunta);
                    }}
                    id={'necessitaConfirmacaoDemandante'}
                  />

                  <FormSelect
                    label={'Campo para informação complementar'}
                    name="necessitaObservacaoDemandante"
                    options={[
                      { text: 'Sim', value: 'True' },
                      { text: 'Não', value: 'False' },
                    ]}
                    required
                    span={2}
                    onChange={e => {
                      setPergunta({
                        ...pergunta,
                        ...{
                          necessitaObservacaoDemandante: e,
                          tiposMinutaObservacaoDemandante: tipoMinutaOptions.map(m => m.value),
                        },
                      } as Pergunta);
                    }}
                    id={'necessitaObservacaoDemandante'}
                  />

                  <FormInput
                    label="Título da Pergunta para o Questionário"
                    name="tituloPerguntaQuestionario"
                    span={2}
                    required
                    onChange={e => {
                      setPergunta({ ...pergunta, tituloPerguntaQuestionario: e.target.value } as Pergunta);
                    }}
                  />

                  {pergunta &&
                    pergunta.necessitaConfirmacaoDemandante &&
                    pergunta.necessitaConfirmacaoDemandante == 'True' && (
                      <FormSelect
                        mode="multiple"
                        label="Tipos de Minuta para a confirmação Demandante"
                        name="tiposMinutaConfirmacaoDemandante"
                        options={tipoMinutaOptions}
                        span={4}
                        showSearch
                        optionFilterProp="children"
                        value={pergunta.tiposMinutaConfirmacaoDemandante}
                        filterOption={(input: any, item: any) => {
                          return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                        }}
                        required
                        onChange={e => {
                          setPergunta({ ...pergunta, tiposMinutaConfirmacaoDemandante: e } as Pergunta);
                        }}
                      />
                    )}

                  <Widget title={'Resposta'}>
                    <TabelaResposta
                      perguntaResult={pergunta ? pergunta : ({} as Pergunta)}
                      atualizarListaPergunta={atualizarListaPergunta}
                    />
                  </Widget>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
        </GridView>

        <GridView icon="editing-drag_reorder" noform id="ordemPergunita" title="ORDENAÇÃO">
          <Collapse
            key="ordenacaoPergunta"
            bordered={false}
            expandIcon={() => <Icon type="arrows-right_4" />}
            defaultActiveKey={'ordenacaoPergunta'}>
            <Panel key="ordenacaoPergunta" header="PERGUNTAS">
              <TabelaPerguntas
                atualizarTelaListaPergunta={atualizarListaPergunta}
                atualizarResultTabelaPerguntaOrdenacao={atualizarResultTabelaPerguntaOrdenacao}
              />
            </Panel>
          </Collapse>
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};

export default Perguntas;
